import { useI18n, t } from "@bookingcom/lingojs-react";

export default function () {
  const i18n = useI18n();
  const getCountryNameFrom = (countryCode: string) => {
    return i18n.trans(t("country", countryCode, "name_from"));
  };
  const getCountryNameArticle = (countryCode: string) => {
    return i18n.trans(t("country", countryCode, "name_article"));
  };
  const getCountryName = (countryCode: string) => {
    return i18n.trans(t("country", countryCode, "name"));
  };
  const getCountryNameIn = (countryCode: string) => {
    return i18n.trans(t("country", countryCode, "name_in"));
  };
  return {
    getCountryName,
    getCountryNameArticle,
    getCountryNameFrom,
    getCountryNameIn
  };
}
